'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('./index.less');

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _galleryResolver = require('./layers/galleryResolver');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var context = require.context('./', true, /\w+\/\w+\.(jsx|js)$/);

var exportObj = {};
var gallery = {
  layers: {},
  layouts: {},
  services: {},
  components: {}
};
context.keys().forEach(function (key) {
  var ks = key.split('/');
  var filename = ks.pop();
  var dirname = ks[ks.length - 2];
  if (gallery[dirname] && _path2.default.basename(filename, _path2.default.extname(filename)) === 'index') {
    Object.assign(gallery[dirname], context(key));
  }
  Object.assign(exportObj, context(key));
});

var components = gallery.components;
gallery.components = {
  hc: components
};
(0, _galleryResolver.setGallery)(gallery);

exports.default = exportObj;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 57
// module chunks = 0